import { render, staticRenderFns } from "./ReceiveRequestHistoriesTab.vue?vue&type=template&id=0e3e7ebc&scoped=true&lang=pug"
import script from "./ReceiveRequestHistoriesTab.vue?vue&type=script&lang=ts"
export * from "./ReceiveRequestHistoriesTab.vue?vue&type=script&lang=ts"
import style0 from "./ReceiveRequestHistoriesTab.vue?vue&type=style&index=0&id=0e3e7ebc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3e7ebc",
  null
  
)

export default component.exports